import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "../../layout/userlayout/layout.component";
import jwtDecode from "jwt-decode";

const PrivateRoute = ({ component: Component, ...rest }) => {
  let user = rest.state.isUserAuthenticated;
  const [dashMenuOpen, setDashMenuOpen] = useState(false)
  //console.log(user);
  let admin = rest.state.isAdminAuthenticated;
  let mobile_number = rest.phone;
  let userData = rest.state.payload ? jwtDecode(rest.state.payload) : null;
  // Fix user type extraction - check both possible structures
  let activeUserType = userData?.user_type || userData?.user?.user_type || userData?.sub || null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <>
            {rest.specialAccess ? (
              <>
                {rest.specialAccess.length !== 0 &&
                  rest.specialAccess.map((item) => (
                    <>
                      {item === activeUserType || activeUserType == 21  ? (
                        <Layout
                        
                          {...props}
                          dashMenuOpen
                          {...rest}
                          key={`${rest.location?.key}-${dashMenuOpen}`}
                          mobile_number={rest.phone}
                          // dashMenuOpen = {dashMenuOpen}
                        >
                          <Component
                            {...props}
                            {...rest}
                            mobile_number={rest.phone}
                            
                            key={rest.location?.key}
                          />
                        </Layout>
                      ) : (
                        <Redirect to="/dashboard" />
                      )}
                    </>
                  ))}
              </>
            ) : (
              <Layout {...props} {...rest} key={rest.location?.key}>
                <Component
                  {...props}
                  {...rest}
                  mobile_number={rest.phone}
                  setDashMenuOpen = {setDashMenuOpen}
                  key={rest.location?.key}
                />
              </Layout>
            )}
          </>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
